import { BellIcon } from '@heroicons/react/24/outline';

interface NotificationBellProps {
  count?: number;
  onClick?: () => void;
}

export function NotificationBell({ count = 0, onClick }: NotificationBellProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="relative rounded-lg p-2 text-secondary hover:bg-[var(--bg-card-hover)] hover:text-[var(--text-primary)]"
      aria-label={count > 0 ? `${count} notifications` : 'Notifications'}
    >
      <BellIcon className="h-5 w-5" />
      {count > 0 ? (
        <span className="absolute right-1 top-1 inline-flex min-h-4 min-w-4 items-center justify-center rounded-full bg-[var(--accent)] px-1 text-[10px] font-semibold text-white">
          {count > 9 ? '9+' : count}
        </span>
      ) : null}
    </button>
  );
}
